import React        from 'react';
import { NavLink }  from 'react-router-dom';
import { getRoute } from 'pursuit/routes/routes';

const CovidWarning = () => {
    return (
        <section className="covid-warning">
            Covid-19 Information:&nbsp;&nbsp;<NavLink to={getRoute('covidInformation')}>Clinic Operations and Covid-19 Updates</NavLink>
        </section>
    )
};

export default CovidWarning;
